import React from 'react';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';
import { Taxonomy } from '@uncinc/react-drupal-core';
import type { Map } from 'immutable';

import './style.scss';

export interface RelatedDossiersProps extends React.HTMLProps<HTMLDivElement> {
  entity: Map<string, any>;
}

const RelatedDossiers: React.FC<RelatedDossiersProps> = ({ entity }) => {
  const entityData = (typeof entity?.toJS === 'function' ? entity.toJS() : entity) as Record<string, any>;
  const title = entityData.field_title?.[0]?.value as string;
  const body = entityData.field_body?.[0]?.processed ?? '';
  const dossiers = entity.get('field_dossiers');
  const classNames = c('Paragraph', 'RelatedDossiers');

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          <div className="col-12">
            <h2>{title}</h2>
          </div>
          <div className="col-12 col-md-9">
            {body && (
              <WysiwygField
                property="schema:text"
                html={body}
              />
            )}
          </div>
        </div>
      </Container>

      <Container>
        <div className="row">
          {dossiers?.map((dossier: Map<string, any>) => {
            const dossierEntity = dossier.get('entity');
            const langcode = dossierEntity.getIn(['langcode', 0, 'value']);
            const id = dossierEntity.getIn(['tid', 0, 'value']);
            const uuid = dossierEntity.getIn(['uuid', 0, 'value']);

            return (
              <div key={`${uuid}:${langcode}`} className="col-12 col-lg-6">
                <Taxonomy
                  id={id}
                  entity={dossierEntity}
                  viewMode="highlighted"
                  className="RelatedDossiers-card"
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default RelatedDossiers;
